<template>
  <HomeCard v-if="statistic">
    <CardHeader title="Lưu lượng sử dụng" icon="fas fa-chart-line" />
    <br/>
    <div class="chart">
       <ve-line :data="statistic" :settings="chartSettings" />
    </div>

  </HomeCard>
</template>

<script>
import { mapState } from "vuex"
import { AUTHENTICATE_STORE } from "@/store/modules/AuthenticateStore.js"
import VeLine from "v-charts/lib/line.common"
import CardHeader from "@/components/HomeComponents/CardHeader.vue"
import HomeCard from "@/components/HomeComponents/HomeCard.vue"
import NumberInfo from "@/components/HomeComponents/NumberInfo.vue"
import { getRecentCreditUsage } from "@/services/authentication_service.js"
import {formatDayMonth} from '@/helpers/timeHelper.js'

export default {
  name: "RecentCreditUsage",
  components: { NumberInfo, HomeCard, CardHeader, VeLine },
  data() {
    return {
      statistic: null,
      chartSettings: {
        labelMap: {
          date: 'Ngày',
          amount: 'Lưu lượng sử dụng'
        }
      }
    }
  },
  computed: {
    ...mapState({
      user: (state) => state[AUTHENTICATE_STORE].user,
    }),
  },
  async mounted() {
    const creditUsage = await getRecentCreditUsage()
    this.statistic = {
      columns: ["date", "amount"],
      rows: creditUsage.map((dayUsage) => ({
        date: formatDayMonth(dayUsage.outgoingDate),
        amount: -dayUsage.amount,
      })),
    }
  },
}
</script>
<style lang="scss" scoped>
  .chart {
    margin: 2rem;
  }
</style>
